export function registerCopyImageLinks(): void {

    // Select all elements with the class 'copyImageLink' and store them in the variable $copyImageLinks
    const $copyImageLinks = document.querySelectorAll<HTMLButtonElement>('.copyImageLink');

    // Check if there are any elements found with the class 'copyImageLink'
    if ($copyImageLinks.length > 0) {
        // Iterate over each element found
        $copyImageLinks.forEach(($copyImageLink) => {
            // Add a click event listener to each element, invoking the onCopyImageLink function when clicked
            $copyImageLink.addEventListener('click', onCopyImageLink);
        });
    }


    /**
     * Handles copyImageLink button click event.
     * Retrieves the image URL, copies it to the clipboard, and displays a success or error message.
     * @param event The mouse event triggered by clicking the copy link button.
     */
    function onCopyImageLink(event: MouseEvent): void {
        const $targetButton = event.currentTarget as HTMLButtonElement;
        const $image = $targetButton.parentElement?.parentElement?.querySelector('img.imagebank-image');

        if ($image) {
            const imageSrc = $image.getAttribute('src');
            const imageUrl = window.location.origin + imageSrc;

            if (imageUrl) {
                navigator.clipboard.writeText(imageUrl)
                .then(() => {
                    // Show the snackbar
                    const snackbar = document.getElementById("snackbarImageBank");
                    if (snackbar) {
                        snackbar.className = "show";
                        // Hide the snackbar/toast after 3 seconds
                        setTimeout(() => { snackbar.className = snackbar.className.replace("show", ""); }, 3000);
                    }
                })
                    .catch(err => {
                        console.error("Kunde inte kopiera länken: ", err);
                        alert("Något gick fel vid kopiering av länken.");
                    });
            } else {
                console.error("Kunde inte hitta bildens URL.");
            }
        } else {
            console.error("Kunde inte hitta bildens element.");
        }
    }
}
